/*
 * @Author: lyx 
 * @Date: 2025-06-16 13:16:37
 * @FilePath: /dbrank_b/src/routes/visualChart/P41/index.js
 * @Description: p41
 */
import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "./index.css";
import Stage from "../components/Stage";
import { convertCanvasToImage, saveFile } from "../../../utils";
import Button from "../components/Button";

class P41 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: []
    };
  }
    // 截图并下载
  captureAndDownload = () => {
    // 通过class选择器获取所有要截图的div
    const divs = document.querySelectorAll(".PageBox");
    const w = divs.offsetWidth;
    const h = divs.offsetHeight;

    Array.from(divs).forEach((div, index) => {
      html2canvas(div, {
        useCORS: true,
        scale: 2, // 将画布的尺寸放大到原始尺寸的两倍
        logging: false,
        foreignObjectRendering: true,
      }).then((canvas) => {
        const src = convertCanvasToImage(canvas).src;
        saveFile(src, `周榜封面`);

        // link.click();
      });
    });
  };

  render() {
    const { mySize, padding } = this.state;
    return (
      // <div style={{ display: 'flex' }}>
      //   <Stage className={s.stage} size={mySize} padding={padding}>
      //     <div className={s.PageBox}>
      //        <div className={s.timeBox} contentEditable>2025年6月2日-6月8日</div>
      //     </div>
      //   </Stage>
      // </div>

      <div className={s.appBox}>
        <Button
          type="primary"
          onClick={this.captureAndDownload}
          style={{ margin: "10px 10px ", display: "inline" }}
        >
          下载
        </Button>

        <div
          className="PageBox"
          style={{
            width: "680px",
            height: "1427px",
          }}
        >
          <div className={s.InnerBox}>
            <div className={s.timeBox} contentEditable>
              2025年6月2日-6月8日
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(P41);



// WEBPACK FOOTER //
// src/routes/visualChart/P41/index.js